<template>
  <div>
    <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
      <div class="card-header mt-4">
        <h1>Modify Database Capacity</h1>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <label>Database Capacity</label>
            <span class="error" v-if="!capacity && !isInputValid"
              >* field required</span
            >
            <v-select
              v-model="capacity"
              :options="capacities.map(c => c.name)"
              @input="onCapacityChanged"
              class="mb-2"
            ></v-select>
            <span v-if="currentCapacity"
              >You are currently using database capacity:
              <b>{{
                capacities.find(c => c.value == currentCapacity).name
              }}</b></span
            >
          </div>

          <div class="col-md-12 text-center mt-6">
            <base-button
              type="primary"
              :disabled="isLoading"
              @click="onSaveChangeClicked()"
              >Save Changes</base-button
            >
          </div>

          <div class="col-md-12 text-center mt-4 mb-3" v-if="success">
            <span class="success"
              >You have modified database capacity successfully.</span
            >
          </div>

          <div class="col-md-12 text-center mt-4 mb-3" v-if="error">
            <span class="failed">{{ error.message }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";

import { MODIFY_DB_CAPACITY, GET_DB_INFO } from "@/store/actions.type";

export default {
  components: {
    vSelect
  },
  data() {
    return {
      capacity: "",
      capacities: [
        { name: "1 ACU (2 GiB RAM)", value: 1 },
        { name: "2 ACU (4 GiB RAM)", value: 2 },
        { name: "4 ACU (8 GiB RAM)", value: 4 },
        { name: "8 ACU (16 GiB RAM)", value: 8 },
        { name: "16 ACU (32 GiB RAM)", value: 16 },
        { name: "32 ACU (64 GiB RAM)", value: 32 },
        { name: "64 ACU (122 GiB RAM)", value: 64 },
        { name: "128 ACU (244 GiB RAM)", value: 128 },
        { name: "256 ACU (488 GiB RAM)", value: 256 }
      ],
      isInputValid: true,
      success: false
    };
  },
  created() {
    this.$store.dispatch(GET_DB_INFO).then(() => {
      this.capacity = this.capacities.find(
        c => c.value == this.currentCapacity
      ).name;
    });
  },
  methods: {
    onSaveChangeClicked() {
      if (this.capacity) {
        this.$store
          .dispatch(MODIFY_DB_CAPACITY, {
            capacity: this.capacities.find(c => c.name == this.capacity).value
          })
          .then(() => {
            this.success = true;
          });
      } else {
        this.isInputValid = false;
      }
    },
    onCapacityChanged(value) {
      this.success = false;
    }
  },
  computed: {
    ...mapState({
      currentCapacity: state => state.configuration.currentCapacity,
      isLoading: state => state.configuration.isLoading,
      error: state => state.configuration.error
    })
  }
};
</script>
<style scoped>
.success {
  color: #ed9304 !important;
  font-size: 18px;
}
.failed {
  color: #fb6340 !important;
  font-size: 18px;
}
</style>
